import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { appPath } from '@fs/zion-config'
import LandingPage from '../../../shared/components/LandingPage/LandingPage'
import icon from '../images/AAM.logo.svg'
import background from '../images/AAM-100.nologo_AAM.png'
import squares from '../images/AAM-squares.svg'

export default function AamLandingPage() {
  const initData = { page_detail: 'All About Me - Landing' }
  usePageView(initData)
  const [t] = useTranslation()
  const createAccountHref = `/register?returnUrl=${encodeURI(`${appPath}/about`)}`
  const guestFields = {
    firstName: true,
    lastName: true,
    birthYear: true,
    languageRegion: true,
  }

  return (
    <LandingPage
      splashImage={background}
      splashImageAlt={t('dlp.discovery-landing-page.aam.title', 'All About Me')}
      headerText={t('dlp.discovery-landing-page.aam.title', 'All About Me')}
      buttonColor="#BD0057"
      data-testid="AAM"
      icon={icon}
      signInHref={`/auth/familysearch/login?returnUrl=${appPath}/about`}
      squares={squares}
      guestFields={guestFields}
      createAccountHref={createAccountHref}
      appName="All About Me"
      title={t('landing-page.aam.page.title', 'All About Me: Your birth year was a vibe—relive it!')}
      description={t(
        'landing-page.aam.page.description',
        'Travel back to your birth year! Explore the music, movies, sports, and headlines—then test your knowledge with fun throwback quizzes.'
      )}
    />
  )
}
